import { Col, Input, Row, Space, Typography } from "antd";
import {useCallback, useEffect, useState} from "react";
import { useGetQuery } from "../../service/query/Queries";
import useDebounce from "../../hooks/useDebounce";
import { useTranslation } from "react-i18next";
import { CiSearch } from "react-icons/ci";
import { ThemesCard } from "../../components";
import {useNavigate} from "react-router-dom";

const { Title } = Typography;

const Ticket = () => {
    const {i18n, t } = useTranslation();
    const [search, setSearch] = useState("");
    const debounceInputValue = useDebounce(search, 500);
    const navigate = useNavigate()
    const {
        data: getTicket,
        refetch: refetchGetTicket,
        isLoading: isLoadingGetTicket,
        isSuccess: isSuccessGetTicket,
    } = useGetQuery(false, "get-product", `ticket/themes/`, false);
    const editHandle = useCallback(( id) => navigate(`/ticket/test?editId=${id}`), [navigate]);

    const filteredTicket = getTicket?.filter((item) =>
        item?.name?.toLowerCase().includes(debounceInputValue.toLowerCase())
    );

    useEffect(() => {
        refetchGetTicket();
    }, [i18n.language]);

    return (
        <div className="site-space-compact-wrapper">
            <Space direction="vertical" size="large" style={{ width: "100%" }}>
                <Row gutter={[10, 20]} align="middle">
                    <Col xs={24} md={12}>
                        <Title className="page--title" level={1} style={{ textAlign: "left" }}>
                            {t("ticket")}
                        </Title>
                    </Col>
                    <Col xs={24} md={12}>
                        <Input
                            size="large"
                            placeholder={t("search")}
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            allowClear
                            prefix={<CiSearch />}
                        />
                    </Col>
                </Row>

                {isLoadingGetTicket && (
                    <div style={{ textAlign: "center", marginTop: 20 }}>
                        <p>{t("loading")}...</p>
                    </div>
                )}

                <Row gutter={[16, 16]}>
                    {isSuccessGetTicket &&
                        filteredTicket?.map((item) => (
                            <Col
                                key={item.id}
                                xs={24}
                                sm={12}
                                md={8}
                                className="gutter-row"
                                style={{ marginTop: 10 }}
                            >
                                <ThemesCard item={item} editHandle={editHandle} />
                            </Col>
                        ))}

                    {isSuccessGetTicket && filteredTicket?.length === 0 && (
                        <Col span={24} style={{ textAlign: "center", marginTop: 20 }}>
                            <p>{t("not_found")}</p>
                        </Col>
                    )}
                </Row>
            </Space>
        </div>
    );
};

export default Ticket;
